import { AssetType } from '@/enum'
import type { IEquipment, IJobAssociatedAsset, IMachine, IVehicle } from '@/interfaces'
import { Vehicle } from '../vehicles'
import { Equipment } from '../equipments'
import { Machine } from '../machine'

class JobAssociatedAsset implements IJobAssociatedAsset {
  id: string
  assetType: AssetType
  vehicleId: string
  vehicle: IVehicle
  equipmentId: string
  equipment: IEquipment
  machineId: string
  machine: IMachine
  title?: string

  constructor(asset?: any) {
    this.id = asset?.id
    this.assetType = asset?.assetType
    this.vehicleId = asset?.vehicleId
    this.vehicle = new Vehicle(asset?.vehicle)
    this.equipmentId = asset?.equipmentId
    this.equipment = new Equipment(asset?.equipment)
    this.machineId = asset?.machineId
    this.machine = new Machine(asset?.machine)

    switch (asset?.assetType) {
      case AssetType.VEHICLE:
        this.title = this.vehicle?.title
        break
      case AssetType.EQUIPMENT:
        this.title = this.equipment?.title
        break
      case AssetType.MACHINE:
        this.title = this.machine?.title
        break
      default:
        break
    }
  }
}

export default JobAssociatedAsset
